module.exports = __webpack_public_path__ + "img/altera.c993ddde.jpg";